// 1. BACKEND BASE URL
// export const BACKEND_BASE_URL = 'http://192.168.100.15:7000';
export const BACKEND_BASE_URL = 'https://api.predixio.co';


// 2. APIs
export const LOGIN = '/api/auth/login/'
export const LOGOUT = '/api/auth/logout/'
export const CHANGE_PASSWORD = '/api/auth/password/change/'
export const VERIFY_EMAIL = '/api/auth/email/verify/'
export const CONFIRM_CODE = '/api/auth/code/confirm/'

// 3. ADMINISTRATION
export const MEMBERS = '/api/hr/member/backoffice/'
export const APP_MEMBERS = '/api/web/member/app/'
export const COMPLETE_PROFILE = '/api/hr/member/profile/complete/'
export const MEMBER_ROLES = '/api/hr/member/role/'
export const REVIEWS = '/api/report/customer/review/'
export const CONTACTS = '/api/core/administration/customer/contact/'
export const PERMISSIONS_TREE = '/api/core/access/permission/tree/'
export const PERMISSIONS_LIST = '/api/core/access/permission/view/'
export const ROLE_PERMISSIONS_TREE = '/api/core/access/permission/role/tree/'
export const ROLE_PERMISSIONS_UPDATE = '/api/core/access/permission/role/update/'


// 4. SETTTINGS
export const STATUSES = '/api/core/settings/status/'
export const MARKETS = '/api/core/settings/market/'
export const SUBSCRIPTIONS = '/api/core/settings/subscription/'
export const APPLICATION_TYPES = '/api/core/settings/application/type/'
export const NOTIFICATION_TYPES = '/api/core/settings/notification/type/'


// 6. DASHBOARD
export const DASHBOARD_SUMMARY = "/api/dashboard/summary/"
export const PREDICTIONS_REPORT_OVERVIEW = "/api/report/predictions/overview/"
export const PREDICTIONS_REPORT_TIMESERIES = "/api/report/predictions/timeseries/"
export const BALANCE_REPORT_TIMESERIES = "/api/report/balance/timeseries/"
export const TRIPLE_PREDICTIONS = "/api/report/predictions/triple/"
export const PREDICTIONS_BY_MARKET = "/api/report/predictions/market/"
export const PREDICTIONS_BY_MARKET_OPTIONS = "/api/report/predictions/market/option/"

// 7. PROFILE
export const MY_LATEST_NOTIFICATIONS = "/api/core/settings/notifications/latest/";
export const MY_NOTIFICATIONS = "/api/core/settings/notifications/view/";


// 8. BET
export const TEAMS = "/api/prediction/app/team/";
export const FIXTURES = "/api/prediction/app/fixture/";
export const MEMBER_PREDICTIONS = "/api/prediction/app/member/";
export const MEMBER_BALANCE = "/api/prediction/app/balance/";
export const INGEST_FIXTURES = "/api/prediction/app/fixtures/ingest/";
export const SETTLE_FIXTURES = "/api/prediction/app/fixtures/settle/";
export const COVERED_COMPETITIONS = "/api/prediction/app/competition/";
export const COMPETITIONS = "/api/bet/competition/coverage/";
export const SYNC_COMPETITIONS = "/api/bet/competition/sync/";
